import * as actionTypes from './actionTypes';

export const initShop = (shop) => {
  return {
    type: actionTypes.FETCH_SHOP,
    shop
  };
};